import React from "react";
import "../styles.css";

const Sidebar = ({ onFilterChange }) => {
  return (
    <div className="sidebar">
      <h2>IGM 2.0</h2>
      <a href="#" onClick={() => { console.log("All Tickets Clicked"); onFilterChange("ALL"); }}>All Tickets</a>
      <a href="#" onClick={() => { console.log("Open Tickets Clicked"); onFilterChange("OPEN"); }}>Open Tickets</a>
      <a href="#" onClick={() => { console.log("Processing Tickets Clicked"); onFilterChange("PROCESSING"); }}>Processing Tickets</a>
      <a href="#" onClick={() => { console.log("Closed Tickets Clicked"); onFilterChange("CLOSED"); }}>Closed Tickets</a>
    </div>
  );
};

export default Sidebar;
